import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsManhattan() {
  return (
    <IntegrationDocTemplate
      title="Manhattan Active Omni"
      category="OMS · DOM · EOM"
      status="live"
      summary="Enterprise Order Management with Distributed Order Management (DOM) and Available-to-Promise (ATP). API-first microservices. Manhattan + Shopify native app (2025 partnership) reduces implementation time. Best for 10K+ orders/month, multi-location, omnichannel (BOPIS, ship-from-store)."
      prerequisites={[
        'Manhattan Active Omni subscription (enterprise contract).',
        'API endpoint + OAuth credentials from Manhattan Customer Portal.',
        'List of locations + sourcing rules + ATP policies.',
      ]}
      connectSteps={[
        'Send us your Manhattan base_url + OAuth credentials via Talk to Sales.',
        'We configure DOM order routing + ATP integration.',
        'First sync: existing locations + sourcing rules + open orders.',
        'CI orders start mirroring to MAO within 5s after each create event.',
      ]}
      syncedData={[
        { type: 'Orders (DOM)', detail: 'CI orders create MAO order records with full line item + ship-to + channel context' },
        { type: 'ATP', detail: 'Real-time available-to-promise across all locations (Manhattan strength)' },
        { type: 'Reservations', detail: 'Inventory reservations per order with auto-expire' },
        { type: 'Routing', detail: 'DOM evaluates location proximity + capacity + cost to pick the best fulfillment node' },
        { type: 'Inventory positions', detail: 'CI ↔ MAO bidirectional inventory sync per location' },
      ]}
      agents={[
        { id: 'erp_sync_agent', name: 'erp_sync_agent', role: 'Bidirectional CI ↔ MAO order + inventory sync' },
        { id: 'order_routing_agent', name: 'order_routing_agent', role: 'Decides routing — uses Manhattan DOM as primary engine' },
        { id: 'atp_agent', name: 'atp_agent', role: 'Multi-location ATP via Manhattan API' },
      ]}
      troubleshooting={[
        { question: 'Implementation slow', answer: 'Standalone Manhattan implementation = 6-12 months. Manhattan + Shopify native app shrinks this to 30-60 days. We strongly recommend the Shopify app path.' },
        { question: 'ATP mismatches CI inventory', answer: 'Manhattan is the source of truth for ATP. Our cache refreshes every 5 min. For real-time accuracy, call atp_agent directly.' },
      ]}
      supportLink="/contact"
    />
  );
}
